import { Directive, ElementRef, EventEmitter, HostListener, OnChanges, Output, SimpleChanges, inject, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserAgentService } from '@library/utils/services/user-agent.service';

@Directive({
  selector: '[route]',
  standalone: false,
})
export class LinkRouterDirective implements OnChanges {
  userAgent = inject(UserAgentService);
  router = inject(Router);
  private readonly el = inject(ElementRef);
  activatedRoute = inject(ActivatedRoute);

  /**
   * route to go to
   */
  readonly route = input<string | string[]>(undefined);

  /**
   * Query parameters
   */
  readonly queryParams = input<Record<string, string>>(undefined);

  /**
   * Event emitted when the link is clicked
   */
  @Output() navigate$ = new EventEmitter();

  readonly resolve = input(true);

  public hasClick = false;

  @HostListener('keydown.enter', ['$event'])
  @HostListener('click', ['$event'])
  goTo(event) {
    if (!this.resolve()) {
      event.preventDefault();
      event.stopPropagation();
      this.hasClick = true;
    }
    else {
      this.navigate();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.hasClick && changes.resolve && changes.resolve.currentValue) {
      this.navigate();
    }
  }

  navigate() {
    this.navigate$.next(null);
    let route: string[];

    const routeValue = this.route();
    if (typeof routeValue === 'string') {
      route = [routeValue];
    }
    else {
      route = routeValue;
    }

    this.router.navigate(route, {
      queryParams: this.queryParams(),
      relativeTo: this.activatedRoute,
      queryParamsHandling: 'merge',
    });
  }
}
